import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import { createPortal } from "react-dom";
import ReactInputMask from "react-input-mask";
import { useHistory, useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { object } from "yup";
import Select from "react-select";
import { CheckCircle } from "react-feather";
import ru from "date-fns/locale/ru";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  getOrderForCorr,
  createReturnRequest,
  getReasonForReturn,
  getReturnRequestOne,
  updateReturnRequestOne,
  createCorrOrder,
  createReturnToProviderFromReturnRequest,
  getReturnRequestStatuses,
} from "services/apiSupply";
import { dateFormat, dateFormatU } from "utils/format";
import { HeaderPage } from "components/HeaderPage";
import { MySpinner } from "components/MySpinner";
import { StatusOrderToProvider } from "components/StatusOrderToProvider";
import { ReturnRequestProductTable } from "features/ReturnRequest/ReturnRequestProductTable";
import { ReturnRequestProductTableNew } from "features/ReturnRequest/ReturnRequestProductTableNew";
import { PrintAct } from "features/ReturnRequest/PrintAct";

import "./returnRequestOne.scss";

registerLocale("ru", ru);

const ReturnRequestSchema = object().shape({
  // name: string().min(2).required(),
  // subject: string().min(2).required()
});

export const ReturnRequestOnePage = () => {
  const { id } = useParams();
  const history = useHistory();
  const [isNew, setIsNew] = useState(!id ? true : false);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [products, setProducts] = useState([]);
  const [returnRequest, setReturnRequest] = useState(null);
  const [reasonsReturn, setReasonsReturn] = useState([]);
  const [reasonsRefusal, setReasonsRefusal] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [showPrintAct, setShowPrintAct] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const getAndSetReturnRequest = () => {
    setLoading(true);
    getReturnRequestOne(id)
      .then((res) => {
        setReturnRequest(res);
        setProducts(res.products);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    getAndSetReasonForReturn();
    getAndSetStatuses();
    if (!id) return;
    getAndSetReturnRequest();
  }, []);

  useEffect(() => {
    if (products.find(v => v.countReturn !== 0)) {
      setIsCorrect(true);
      return;
    }
    setIsCorrect(false);

  }, [products]);

  const submitHandler = (values) => {

    if (!isCorrect) {
      toast.error('Выберите товар!');
      return;
    }
    setLoading(true);

    if (!id) {

      createReturnRequest({
        date: values.date,
        order: values.order,
        comment: values.comment,
        reasonReturn: values.reasonReturn?.value,
        reasonRefusal: values.reasonRefusal?.value,

        products: products.filter(v => v.countReturn > 0).map(v => ({
          orderProduct: v.id,
          count: v.countReturn
        }))
      })
        .then((res) => {
          history.push(res.id);
          toast.success("Заявка на возврат успешно создана");
        })
        .catch((e) => {
          toast.error(e.response?.data?.message);
        })
        .finally(() => setLoading(false));

    } else {

      updateReturnRequestOne(id, {
        date: dateFormatU(values.date),
        comment: values.comment,
        reasonReturn: values.reasonReturn?.value,
        reasonRefusal: values.reasonRefusal?.value,
        status: values.status?.id,
        returnDecline: values.returnDecline,
      })
        .then((res) => {
          history.push(res.id);
          toast.success("Изменение успешно сохранены");
        })
        .catch((e) => {
          toast.error(e.response?.data?.message);
        })
        .finally(() => setLoading(false));
    }
  }

  const statusHandler = (val, values, setFieldValue) => {
    setFieldValue("status", val);
    setLoading(true);
    updateReturnRequestOne(id, {
      status: val.id
    })
      .then((res) => {
        toast.success("Статус успешно изменен");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  }

  const getAndSetReasonForReturn = () => {
    getReasonForReturn()
      .then((res) => {
        setReasonsReturn(Object.entries(res.return).map(v => ({ label: v[1], value: parseInt(v[0]) })));
        setReasonsRefusal(Object.entries(res.refusal).map(v => ({ label: v[1], value: parseInt(v[0]) })));
      })
      .catch((e) => console.error(e))
      .finally(() => { });
  }

  const getAndSetStatuses = () => {
    getReturnRequestStatuses()
      .then((res) => {
        setStatuses(res);
      })
      .catch((e) => console.error(e));
  };

  const getAndSetOrder = (orderNumber, setFieldValue) => {
    if (!orderNumber) return;
    setLoading(true);
    getOrderForCorr(orderNumber)
      .then((res) => {
        setOrder(res);
        setProducts(
          res.products.map((val) => ({ ...val, countReturn: 0 }))
        );
        setFieldValue("order", res.id);
        setFieldValue("orderNumber", orderNumber);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  const createCorr = (values) => {
    if (returnRequest?.corrOrder.length > 0) {
      toast.error("Корр. сч. факт уже была создана");
      return;
    }
    setLoading(true);
    createCorrOrder({
      order: {
        id: values.order,
      },
      returnRequest: id,
      products: products.map((val) => ({
        ...val,
        id: val.orderProduct.id,
        countAfter: val.orderProduct.countBefore - val.count,
        countBefore: val.orderProduct.countBefore
      })),
      reasonReturn: values.reasonReturn?.value,
      reasonRefusal: values.reasonRefusal?.value,
    })
      .then((res) => {
        getAndSetReturnRequest();
        toast.success("Корректировка успешно создана");
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
        setLoading(false);
      })
      .finally(() => { });
  }

  const createReturnToProvider = (values) => {
    if (returnRequest?.returnToProvider.length > 0) {
      toast.error("Возврат поставщику уже был создан");
      return;
    }
    setLoading(true);
    createReturnToProviderFromReturnRequest({ id })
      .then((res) => {
        getAndSetReturnRequest();
        toast.success("Возврат поставщику успешно создан");
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e.response?.data?.message);
      })
      .finally(() => { });
  }

  const renderTitle = (number) => {
    console.log(number);
    if (!number) {
      return `Новая заявка на возврат`;
    }

    return `Заявка на возврат № ${number || ""}`;
  };

  return (
    <>
      <>{createPortal(
        <>
          {showPrintAct &&
            <PrintAct returnRequest={returnRequest} setShowPrintAct={setShowPrintAct} />
          }
        </>,
        document.body
      )}
      </>

      <Container fluid className="p-0 return-request-one">

        {loading && <MySpinner overlay />}
        <Formik
          initialValues={{
            number: returnRequest?.returnRequest.number || "",
            admin: returnRequest?.admin?.name || "",
            orderNumber: returnRequest?.order?.number || "",
            order: returnRequest?.order?.id || "",
            orderCustomer: returnRequest?.order?.customer || "",
            orderShippingDate: returnRequest?.order?.shippingDate || "",
            date: returnRequest?.returnRequest?.date ? new Date(returnRequest?.returnRequest?.date) : new Date(),
            returnDecline: returnRequest?.returnRequest?.returnDecline || "",
            status: returnRequest ? {
              ...returnRequest?.status,
              label: returnRequest?.status.name,
              value: returnRequest?.status.id
            } : null,
            reasonReturn: returnRequest?.returnRequest?.reasonReturn?.id ? {
              label: returnRequest?.returnRequest?.reasonReturn?.name,
              value: returnRequest?.returnRequest.reasonReturn.id
            } : null,
            reasonRefusal: returnRequest?.returnRequest?.reasonRefusal?.id ? {
              label: returnRequest?.returnRequest.reasonRefusal.name,
              value: returnRequest?.returnRequest.reasonRefusal.id
            } : null,
            comment: returnRequest?.returnRequest.comment || "",
          }}
          validationSchema={ReturnRequestSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            submitHandler(values);
            setSubmitting(false);
          }}
          enableReinitialize={returnRequest?.id ? true : false}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (

            <form onSubmit={handleSubmit}>

              <Helmet>
                <title>{renderTitle(values?.number)}</title>
              </Helmet>

              <HeaderPage title={renderTitle(values?.number)}>

                <div className="return-request-one__date-block">
                  <Label>Дата</Label>
                  <DatePicker
                    name="date"
                    placeholderText="Дата возврата"
                    selected={values.date}
                    selectsStart
                    dateFormat="dd.MM.yyyy"
                    locale="ru"
                    onChange={val => setFieldValue("date", val)}
                    className="form-control date"
                    customInput={<ReactInputMask mask={"99.99.9999"} />}
                    invalid={
                      errors.date && touched.date
                        ? errors.date
                        : null
                    }
                  />
                </div>

              </HeaderPage>

              <Card className="return-request-one__form mb-0">
                <CardBody className="pb-3">

                  {isNew ? (
                    <>
                      <Row>
                        <Col md={8}>
                          <Label className="text-sm-right">На основании заказа</Label>
                          <InputGroup>
                            <Input
                              name="orderNumber"
                              placeholder="Заказ"
                              value={values?.orderNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <Button color="primary" onClick={() => getAndSetOrder(values?.orderNumber, setFieldValue)}>
                              загрузить
                            </Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">Клиент</Col>
                        <Col md="9">
                          <b>{order?.orgNameShort}</b>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">Дата реализации</Col>
                        <Col md="9">
                          <b>{dateFormat(order?.shippingDate)}</b>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col md="3">
                          <Label className="text-sm-right">Заказ: </Label>
                        </Col>
                        <Col md="9">
                          <b>
                            <Link to={`/sales/orders/${values?.order}`} target="_blank" rel="noreferrer">
                              № {values?.orderNumber}
                            </Link>
                          </b>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">
                          <Label className="text-sm-right">Клиент: </Label>
                        </Col>
                        <Col md="9">
                          <b>{values?.orderCustomer}</b>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">Дата реализации</Col>
                        <Col md="9">
                          <b>{dateFormat(values?.orderShippingDate)}</b>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    <Col md="6" className="elem-field">
                      <Label className="text-sm-right">Причина возврата</Label>
                      <Select
                        name="reasonReturn"
                        placeholder="Выберите причину возврата"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={reasonsReturn}
                        onChange={val => setFieldValue("reasonReturn", val)}
                        value={values.reasonReturn}
                        invalid={
                          errors.reasonsReturn && touched.reasonsReturn
                            ? errors.reasonsReturn
                            : null
                        }
                      />
                    </Col>
                    {values.reasonReturn?.value === 1 &&
                      <Col md="6" className="elem-field">
                        <Label className="text-sm-right">Причина отказа</Label>
                        <Select
                          name="reasonRefusal"
                          placeholder="Выберите причину отказа"
                          className="react-select-container"
                          classNamePrefix="react-select"
                          options={reasonsRefusal}
                          onChange={val => setFieldValue("reasonRefusal", val)}
                          value={values.reasonRefusal}
                          invalid={
                            errors.reasonRefusal && touched.reasonRefusal
                              ? errors.reasonRefusal
                              : null
                          }
                        />
                      </Col>
                    }
                  </Row>
                  <Row>
                    <Col>
                      <Label className="text-sm-right">Комментарий</Label>
                      <Input
                        type="textarea"
                        name="comment"
                        placeholder="Комментарий"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.comment}
                      />
                    </Col>
                  </Row>
                  {values?.status?.alias === 'rejected' &&
                    <Row>
                      <Col>
                        <Label className="text-sm-right">Причина отказа в возврате</Label>
                        <Input
                          type="textarea"
                          name="returnDecline"
                          placeholder="Причина отказа в возврате"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.returnDecline}
                        />
                      </Col>
                    </Row>
                  }
                  {!isNew && (
                    <>
                      <Row>
                        <Col md="3">
                          <Label className="text-sm-right">Автор</Label>
                        </Col>
                        <Col md="9">
                          {values.admin}
                        </Col>
                      </Row>

                      {values?.status?.alias !== 'rejected' &&
                        <>
                          <Row>
                            <Col md="3">
                              <Label className="text-sm-right">Корр сч.факт</Label>
                            </Col>
                            <Col md="9">
                              {returnRequest?.corrOrder.map(val =>
                                <>
                                  <a href={`/sales/corrOrders/${val.id}`}
                                    target="_blank" rel="noreferrer"
                                    key={val.id}
                                  >
                                    № {val.number}
                                  </a>{' '} {val.carryOut && <CheckCircle color="green" />}
                                </>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col md="3">
                              <Label className="text-sm-right">Возврат поставщику</Label>
                            </Col>
                            <Col md="9">
                              {returnRequest?.returnToProvider.map(val =>
                                <>
                                  <a href={`/receipt/returnsToProvider/${val.id}`}
                                    target="_blank" rel="noreferrer"
                                    key={val.id}
                                  >
                                    № {val.number}
                                  </a>{' '} {val.carryOut && <CheckCircle color="green" />}
                                </>
                              )}
                            </Col>
                          </Row>
                        </>
                      }
                    </>
                  )}

                  <Row className="mt-4">
                    <Col md="3">
                      <StatusOrderToProvider
                        status={values.status}
                        statuses={statuses}
                        statusHandler={val => statusHandler(val, values, setFieldValue)}
                      >
                        {values.status?.name}
                      </StatusOrderToProvider>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button onClick={() => setShowPrintAct(true)}>
                        Печать акта
                      </Button>

                      {values?.status?.alias !== 'rejected' &&
                        <>
                          <Button className="ml-2" onClick={() => createCorr(values)}>
                            Создать корр.сч.факт
                          </Button>
                          <Button className="ml-2" onClick={() => createReturnToProvider(values)}>
                            Создать возврат поставщику
                          </Button>
                        </>
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {isNew ? (
                <ReturnRequestProductTableNew
                  products={products}
                  setProducts={setProducts}
                />
              ) : (
                <ReturnRequestProductTable
                  products={products}
                  setProducts={setProducts}
                  loading={loading}
                  setLoading={setLoading}
                />
              )}

              <Card>
                <CardBody>
                  <Button
                    color="primary"
                    className="button-wide"
                    type="submit"
                  >
                    Сохранить
                  </Button>
                </CardBody>
              </Card>
            </form>
          )}
        </Formik>
      </Container>
    </>
  );
}